export default __webpack_public_path__ + "static/media/web.555003ca.svg";